<template lang='pug' src='./Filters.pug'></template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'Filters',
    data: function () {
      return {
        filters: {
          order: '',
          author: ''
        }
      }
    },
    computed: mapGetters({
      orders: 'getOrders',
      authors: 'getAuthors',
      getFiltersVisibility: 'getFiltersVisibility'
    }),
    watch: {
      filters: {
        handler: function (currentValue) {
          const FILTER = {}

          if (currentValue.order) {
            FILTER.orderBy = currentValue.order
          }

          if (currentValue.author) {
            FILTER.authorId = currentValue.author
          }

          this.filterQuotes(FILTER)
        },
        deep: true
      }
    },
    methods: {
      showMobileFilters: function () {
        this.changeFiltersVisibility()
      },
      ...mapActions([
        'filterQuotes',
        'changeFiltersVisibility'
      ])
    }
  }
</script>

<style lang='css' src='./Filters.css' scoped></style>



// WEBPACK FOOTER //
// Filters.vue?300136ed